import { useQuery } from '@tanstack/react-query';
import { getAlert } from '../alertApi';
import { MonitoringAlertDto } from '../alertApi';
import { MonitorAlertFullDto } from '@/app/Alert/types';
import { fetchAlert } from '@/lib/api/monitoring/alert';
import { axiosClientAdmin } from '@/lib/auth';

export const useGetAlert = (alertId: string) => {
  return useQuery<MonitoringAlertDto, Error>({
    queryKey: ['alert', alertId],
    queryFn: () => getAlert(alertId),
    enabled: !!alertId,
  });
};

export const useGetFullAlert = (alertId: string | undefined) => {
  return useQuery<MonitorAlertFullDto, Error>({
    queryKey: ['fullAlert', alertId],
    queryFn: () => {
      if (!alertId) {
        throw new Error('Alert ID is required');
      }
      return fetchAlert(alertId) as Promise<MonitorAlertFullDto>;
    },
    enabled: !!alertId,
  });
};

export const useGetFullAlertAdmin = (alertId: string | undefined) => {
  return useQuery<MonitorAlertFullDto, Error>({
    queryKey: ['fullAlert', alertId],
    queryFn: async () => {
      if (!alertId) {
        throw new Error('Alert ID is required');
      }
      const { data } = await axiosClientAdmin.get<{ alert: MonitorAlertFullDto }>(
        `/Monitoring/alerts/${alertId}/full`
      );
      return data.alert;
    },
    enabled: !!alertId,
  });
};